/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";






const Goto = (props) => {
    const _refundRequestID = (props.match.params.RefundRequestID  !== undefined) ? props.match.params.RefundRequestID  : null;
    console.log("goto");
    console.log(_refundRequestID);
    useEffect(() => {
        axios({
            method: 'post',
            url: "/api/v1/currentdate",
            headers: { 'referpage': '/refund/request' }
        })
        .then(
            result => {

                if (_refundRequestID != null && _refundRequestID != '') {
                    props.history.push({
                        pathname: '/refund/request',
                        state: {
                            refundRequestID : _refundRequestID
                        }
                    })
                }

            },
            error => {
                props.history.push({
                    pathname: '/auth/login-page',
                    state: {
                        redirect: '/refund/id/' + _refundRequestID
                    }
                })
            }
        );  

       


    }, [])

    return (

        <div>

       
        </div>
    );

}





export default Goto;